import { useFlow } from '@router/stackflow';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

function useOrderComplete(orderNo: string) {
    const { replace, push } = useFlow();
    const [_, __, removeCookie] = useCookies(['tempOrder']);
    useEffect(() => {
        replace('MainActivity', {}, { animate: false });
        push('OrderLogsActivity', { duration: 'ALL' }, { animate: false });
        push('OrderLogActivity', { orderNo });
        removeCookie('tempOrder', { path: '/' });
    }, [orderNo]);
}

export default useOrderComplete;
